import React from 'react';

const ContainItem = ({children}) => {
    return (
        <div className='pb-[150px]'>
            {children}
        </div>
    );
};

export default ContainItem;